import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { DigitCodeInput } from '../digit-code-input/DigitCodeInput'
import useCountDown from '../../../../../hooks/useCountDown'
import { Button, BUTTON_COLOR } from '../../../../atoms'

const TEST_ID = 'login-modal-sign-up-code'

interface LoginModalValidateDigitCodeFormProps {
  isLoading: boolean
  onValidateDigitCode: ({
    digitsVerificationCode,
    email,
  }: {
    digitsVerificationCode: string
    email: string
  }) => void
  onRequestNewDigitCode: ({ email }: { email: string }) => void
  userEmail: string
  errorMessage?: string
}
export const LoginModalValidateDigitCodeForm = ({
  isLoading,
  onValidateDigitCode,
  onRequestNewDigitCode,
  userEmail,
  errorMessage,
}: LoginModalValidateDigitCodeFormProps) => {
  const [digitCode, setDigitCode] = useState<string>('')
  const { countDown, startCountDown } = useCountDown()

  const handleOnValidateDigitCode = () => {
    if (!digitCode) {
      return
    }

    onValidateDigitCode({ digitsVerificationCode: digitCode, email: userEmail })
  }
  const handleOnRequestNewDigitCode = () => {
    startCountDown({ startingValueInSeconds: 60 })
    onRequestNewDigitCode({ email: userEmail })
  }

  useEffect(() => {
    if (digitCode.length >= 6) {
      handleOnValidateDigitCode()
    }
  }, [digitCode])

  return (
    <div className={s.container}>
      <div className={s.wrapper}>
        <p className={s.text}>
          <FormattedMessage
            id='ui.loginModalValidateDigitCode.intro'
            defaultMessage="Saisissez le code que nous vous avons envoyé par mail à votre adresse e-mail. Veuillez consulter votre dossier de courriers indésirables s'il ne se trouve pas dans votre boite de réception"
          />
        </p>

        <div className={s.inputContainer}>
          <p className={s.inputLabel}>
            <FormattedMessage
              id='ui.loginModalValidateDigitCode.enterCode'
              defaultMessage='Entrez le code de vérification reçu par e-mail'
            />
          </p>
          <DigitCodeInput
            digitCode={digitCode}
            setDigitCode={setDigitCode}
            disabled={isLoading}
            testId={TEST_ID}
          />
          {errorMessage && (
            <span className={s.errorMessage} data-testid={`${TEST_ID}-error`}>
              {errorMessage}
            </span>
          )}
        </div>
      </div>

      <div className={s.buttonsContainer}>
        <Button
          className={s.submitButton}
          loading={isLoading}
          onClick={handleOnValidateDigitCode}
          disabled={!digitCode}
          fullWidth={true}
        >
          <FormattedMessage
            id='ui.loginModalValidateDigitCode.validate'
            defaultMessage='Valider'
          />
        </Button>

        <Button
          className={clsx(s.resendCodeButton, {
            [s.disabled]: isLoading || Boolean(countDown),
          })}
          onClick={handleOnRequestNewDigitCode}
          color={BUTTON_COLOR.TERTIARY}
          fullWidth={true}
        >
          <FormattedMessage
            id='ui.loginModalValidateDigitCode.resendCode'
            defaultMessage='Renvoyer le code {countDown}'
            values={{
              countDown: countDown ? `(${countDown}s)` : null,
            }}
          />
        </Button>
      </div>
    </div>
  )
}
